export default {
  chatEnabled: false,
  sessions: [],
  currentSession: {},
  messages: {
    all: []
  },
  userCreating: false,
  systemCreating: false,
  loading: {
    allSessions: false,
    session: false,
    message: false,
    messages: false
  },
  messageQueue: [],
  sendingFromQueue: false
}
